<template>
<van-popup
  :show="show"
  round
  teleport="body"
  :z-index="3000"
  @close="handleCloseClick"
>
  <div class="switch-wrapper">
    <p class="title">Click to choose country</p>

    <ul class="country-list">
      <li
        v-for="item in previewCountrys"
        :key="item.id"
        class="country" 
        @click="handleCountryClick(item)"
      >
        <img class="country-icon" v-lazy="$cvWebpFn(item?.flag || '')" alt="">
        <span class="country-name">{{  item.name }}</span>
      </li>
    </ul>
  </div>
</van-popup>
</template>

<script setup lang="ts">
import { getSelectableRegions } from '@/utils/region'

interface IProps {
  show: boolean
  type?: WithCodeType
}
interface IEmits{
  (e: 'update:show', show: boolean):void
  (e: 'country:click', country: region.IRegionItem):void
}
const props = withDefaults(
  defineProps<IProps>(),
  {
    show: false
  }
)
const emits = defineEmits<IEmits>()

const countrys = useCountrys()
const previewCountrys = computed(() => getSelectableRegions(countrys.value || []))
const handleCloseClick = () => {
  emits('update:show', false)
}
const handleCountryClick = (e: region.IRegionItem) => {
  emits('country:click', e)
  handleCloseClick()
}
</script>

<style lang="scss" scoped>
.switch-wrapper{
  padding: 30px;
}
.title{
  font-size: 28px;
  text-align: center;
  margin-bottom: 20px;
}
.country-list{
  font-size: 28px;
  padding: 40px;
  width: 580px;
  .country{
    border-radius: 12px;
    margin: 30px 0;
    padding: 20px 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f5f5f5;
    .country-icon{
      width: 80px;
      height: 56px;
    }
    .country-name{
      color: #333;
    }
  }
}
</style>